export enum EEventStatus {
    IN_PROGRESS = 'IN_PROGRESS',
    WITHDRAWN_CANCELLED = 'WITHDRAWN_CANCELLED',
    COMPLETED = 'COMPLETED'
}

export enum EEventType {
    DIC = 'DIC',
    CHANGE_LEGAL_NAME = 'CHANGE_LEGAL_NAME',
    CHANGE_OTHER_NAMES = 'CHANGE_OTHER_NAMES',
    CHANGE_LEGAL_ADDRESS = 'CHANGE_LEGAL_ADDRESS',
    CHANGE_HQ_ADDRESS = 'CHANGE_HQ_ADDRESS',
    CHANGE_LEGAL_FORM = 'CHANGE_LEGAL_FORM',
    OSTATNI = 'OSTATNI',
    VZNIKSPOLECNOSTI = 'VZNIKSPOLECNOSTI'
}
